import React, {PropTypes, Component} from 'react';
import rcUtil from 'rc-util';

class Marks extends Component {
  render() {
    const {className, marks, included, upperBound, lowerBound, max, min} = this.props;
    const marksKeys = Object.keys(marks);
    const marksCount = marksKeys.length;
    const unit = 100 / (marksCount - 1);
    const markWidth = unit * 0.9;

    const range = max - min;
    const elements = marksKeys.map(parseFloat).map((point) => {
      const isActived = (!included && point === upperBound) ||
              (included && point <= upperBound && point >= lowerBound);
      const markClassName = rcUtil.classSet({
        [className + '-text']: true,
        [className + '-text-active']: isActived,
      });

      const style = {width: markWidth + '%'};
      style.left = (point - min) / range * 100 - markWidth / 2 + '%';

      return (<span className={markClassName} style={style} key={point}>
               {marks[point]}
              </span>);
    });

    return <div className={className}>{elements}</div>;
  }
}

Marks.propTypes = {
  className: PropTypes.string.isRequired,
  marks: PropTypes.object.isRequired,
  included: PropTypes.bool.isRequired,
  upperBound: PropTypes.number.isRequired,
  lowerBound: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired
};

// export default Marks;
//
// const Marks = ({className, marks, included, upperBound, lowerBound, max, min}) => {
//
// };

export default Marks;
